



















// Import vendors ----------------------------------------------------------------------------------
import { computed, defineComponent, toRefs } from '@vue/composition-api';
// Import types ------------------------------------------------------------------------------------
import type { PropType } from '@vue/composition-api';
import type { FormFieldText } from '@/utils/forms.utils';
// -------------------------------------------------------------------------------------------------

export default defineComponent({
  name: 'FormFieldTextArea',
  inheritAttrs: false,
  props: {
    field: {
      type: Object as PropType<FormFieldText>,
      required: true
    }
  },
  setup(properties, { slots }) {
    // Use this property to have typing in DOM
    const { field } = toRefs(properties);

    const hasProgressSlot = computed(() => {
      return Boolean(slots.progress);
    });

    return {
      f: field as any as FormFieldText,
      // Flags
      hasProgressSlot
    };
  }
});
